'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sparkCore = require('@ciscospark/spark-core');

var _meetings = require('./meetings');

var _meetings2 = _interopRequireDefault(_meetings);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _sparkCore.registerPlugin)('meetings', _meetings2.default, {
  config: _config2.default
}); /* eslint-env browser */
// Any references to 'ciscospark' should be removed once this becomes an actual plugin

exports.default = _meetings2.default;
//# sourceMappingURL=index.js.map
